class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.curtain = document.getElementById('curtain');
    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.captionSingular = this.querySelector('[data-caption-singular]');
    this.captionPlural = this.querySelector('[data-caption-plural]');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');
    this.curtain.classList.add('curtain--visible');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    this.curtain.classList.remove('curtain--visible');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(cartItemKey, sections = {}) {
    const multipleItemsAdded = cartItemKey === 'multiple';
    this.getSectionsToRender(cartItemKey).forEach((section => {
      const sectionElement = document.getElementById(section.id);
      /*
        Need to hide the product image/info when multiple products are added to the cart
      */
      if (section.id === 'cart-notification-product') {
        sectionElement.classList.toggle('hidden', multipleItemsAdded);

        if (multipleItemsAdded) return;
      }

      sectionElement.innerHTML =
        this.getSectionInnerHTML(sections[section.id], section.selector);
    }));

    this.captionSingular.classList.toggle('hidden', multipleItemsAdded);
    this.captionPlural.classList.toggle('hidden', !multipleItemsAdded);

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender(cartItemKey) {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
